import { render, staticRenderFns } from "./PageBuilders.vue?vue&type=template&id=2c66bf8a&"
import script from "./PageBuilders.vue?vue&type=script&lang=js&"
export * from "./PageBuilders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports